
import * as React from 'react';
import { css } from 'emotion';
import { components } from '@peachjar/components';
import Typo from '@peachjar/ui/dist/lib/typography/TypographyRedux';
const { VerticalNav } = components;


type Props = {
  path: string,
  label: string,
  badge?: React.ReactNode,
};

const SidebarItem = ({ path, label, badge }: Props) => (
  <VerticalNav.Item path={path} label={label}>
    <Typo.Dark.Note className={classNames.spaceBetween}>
      {label}
      {badge}
    </Typo.Dark.Note>
  </VerticalNav.Item>
);

SidebarItem.defaultProps = {
  badge: null,
};

const classNames = {
  spaceBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
};

export default SidebarItem;
